import { TabBar as TB } from "antd-mobile";
import { GiftOutlined, LockOutlined, TeamOutlined } from "@ant-design/icons";
import Account from "../Icons/Account";
import { RoutePaths } from "../routes";
import { generatePath, Link, useLocation, useNavigate } from "react-router";
import { useSelector } from "react-redux";
import { useCurrentRoute, useLoadMyDefaultWishlistId } from "../../data/hooks";
import Button from "./Button";
import { selectIsSignedIn } from "@/data/redux/user/selectors";

export default function TabBar() {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const myDefaultWishlistId = useLoadMyDefaultWishlistId();
  const myDefaultWishlistPath = generatePath(RoutePaths.specificWishlist, {
    wishlistId: myDefaultWishlistId || "",
  });
  const activeKey =
    pathname === RoutePaths.myDefaultWishlist ||
    pathname === myDefaultWishlistPath
      ? RoutePaths.myDefaultWishlist
      : pathname;
  const isSignedIn = useSelector(selectIsSignedIn);
  const currentRoute = useCurrentRoute();

  if (!isSignedIn) {
    if (currentRoute !== RoutePaths.specificWishlist) {
      return <></>;
    }

    return (
      <div className="fixed bottom-0 w-full p-10 md:hidden">
        <Link to={RoutePaths.login} viewTransition>
          <Button shadow large>
            Sign in
          </Button>
        </Link>
      </div>
    );
  }

  const onClick = (key: string) => {
    navigate(key);
  };

  return (
    <TB
      onChange={onClick}
      defaultActiveKey={activeKey}
      className="wish-border-top wish-bg-surface fixed inset-x-0 bottom-0 h-16 md:hidden"
    >
      <TB.Item
        key={RoutePaths.myDefaultWishlist}
        icon={<GiftOutlined />}
        title={"Wishlist"}
      />
      <TB.Item
        key={RoutePaths.friends}
        icon={<TeamOutlined />}
        title={"Friends"}
      />
      <TB.Item
        key={RoutePaths.reserved}
        icon={<LockOutlined />}
        title={"Reserved"}
      />
      <TB.Item key={RoutePaths.account} icon={<Account />} title={"Profile"} />
    </TB>
  );
}
